import { useLanguage } from '@/contexts/LanguageContext';
import FadeIn from '@/components/FadeIn';
import { Gift } from 'lucide-react';

export default function ProdutosSection() {
  const { t } = useLanguage();

  return (
    <section
      id="produtos"
      data-testid="section-produtos"
      className="min-h-screen flex flex-col justify-center px-8 md:px-16 lg:px-24 py-24 relative"
    >
      <FadeIn>
        <h2
          data-testid="produtos-title"
          className="text-3xl md:text-4xl lg:text-5xl font-light text-[#35589B] tracking-tight leading-tight mb-8"
        >
          {t.produtos.title}
        </h2>
      </FadeIn>

      <FadeIn delay={0.2}>
        <p
          data-testid="produtos-subtitle"
          className="text-base md:text-lg font-light text-[#333333]/90 leading-relaxed max-w-xl mb-12"
        >
          {t.produtos.subtitle}
        </p>
      </FadeIn>

      {/* Product card - Coming Soon */}
      <FadeIn delay={0.4}>
        <button
          data-testid="product-coming-soon-card"
          className="group flex flex-col items-center p-10 rounded-2xl bg-[#F3F1EC]/60 border border-[#333333]/5 hover:border-[#35589B]/20 transition-all duration-500 max-w-sm cursor-pointer"
          onClick={() => {/* Future: navigate to products page */}}
        >
          <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-[#F8C3A8]/30 to-[#C2A8F7]/30 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500">
            <Gift
              size={28}
              className="text-[#35589B]/60 group-hover:text-[#35589B] transition-colors duration-500"
            />
          </div>
          <p
            data-testid="produtos-coming-soon"
            className="text-sm font-light text-[#333333]/60 text-center leading-relaxed"
          >
            {t.produtos.comingSoon}
          </p>
        </button>
      </FadeIn>
    </section>
  );
}
